import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import { ToastProvider } from './components/Toast';
import { OnboardingProvider } from './OnboardingContext';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ScreenManager from './pages/ScreenManager';
import HotspotEditor from './pages/HotspotEditor';
import Preview from './pages/Preview';
import PackageBuilder from './pages/PackageBuilder';
import ScreenshotManager from './pages/ScreenshotManager';
import VerifyEmail from './pages/VerifyEmail';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function AppContent() {
  const location = useLocation();
  const hideFooter = location.pathname.includes('/preview');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <a href="#main-content" style={{
        position: 'absolute', left: '-9999px', top: 'auto', width: 1, height: 1, overflow: 'hidden',
        zIndex: 9999, padding: '8px 16px', background: '#4f46e5', color: '#fff', fontWeight: 600,
      }}
        onFocus={e => { e.target.style.left = '8px'; e.target.style.width = 'auto'; e.target.style.height = 'auto'; }}
        onBlur={e => { e.target.style.left = '-9999px'; e.target.style.width = '1px'; e.target.style.height = '1px'; }}
      >Skip to main content</a>
      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/projects/:id" element={<PrivateRoute><ScreenManager /></PrivateRoute>} />
          <Route path="/projects/:id/edit/:screenId" element={<PrivateRoute><HotspotEditor /></PrivateRoute>} />
          <Route path="/projects/:id/preview" element={<PrivateRoute><Preview /></PrivateRoute>} />
          <Route path="/packages/new" element={<PrivateRoute><PackageBuilder /></PrivateRoute>} />
          <Route path="/packages/:id" element={<PrivateRoute><PackageBuilder /></PrivateRoute>} />
          <Route path="/screenshots" element={<PrivateRoute><ScreenshotManager /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </div>
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <OnboardingProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </OnboardingProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;